import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Button, Grid, IconButton, Hidden } from "@material-ui/core";
import { CourseCard, MUIProgressBar } from "../../../MUI";
import * as styles from "./styles.scss";
import { tl } from "../../../../../utils";

import { UploadPanel } from "./UploadPanel";
import { SvgIcon } from "../../../../../components";

import { ICourse } from "../../types";
import FSStore from "../../store";
import FSCourseStore from "../store";
import FSTabsStore from "../Tabs/store";

export const Head = observer(() => {
  const { fsStore, fsCourseStore, fsTabsStore } = React.useContext<{
    fsStore: FSStore;
    fsCourseStore: FSCourseStore;
    fsTabsStore: FSTabsStore;
  }>(MobXProviderContext);

  const course: ICourse = {
    id: fsStore.course_id,
    icon: fsStore.course_cover,
    name: fsStore.course_name,
    title: ''
  };

  const onFileuploadAbort = () => {
    fsCourseStore.cancelToken();
    fsCourseStore.setFileUploadMessage(tl("Загрузка файла отменена"));
    setTimeout(() => {
      fsCourseStore.setFileUploadMessage("");
    }, 2000);
  };

  const addVideoByLink = () => {
    // TODO: file by link
  };

  return (
    <>
      <Box p={2} bgcolor="grey.A200" className={styles.head}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs className={styles.title}>
            <Hidden only="xs">{fsTabsStore.getFSTitle}</Hidden>
            <Hidden smUp>{fsTabsStore.getFSTitleMobile}</Hidden>
          </Grid>
          {fsStore.isWidget ? (
            <Hidden smUp>
              <Grid item onClick={fsStore.onCancel}>
                <SvgIcon type="search-clear" />
              </Grid>
            </Hidden>
          ) : null}
          {!!fsStore.course_id && !!fsCourseStore.isHaveFilesInCourse && fsStore.rootStore.fsCourseStore.filterFilesType !== 'transcription' ? (
            <UploadPanel />
          ) : null}
        </Grid>
      </Box>
      {fsCourseStore.isFileUploadInProgress ||
      fsCourseStore.fileUploadMessage ? (
        <Box px={2} py={1} className={styles.upload}>
          {fsCourseStore.isFileUploadInProgress ? (
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                {fsCourseStore.fileUploadCurrentProgress >= 100 ? (
                  <span
                    title={tl(
                      "Файл находится в обработке для того, чтобы его можно было посмотреть в любом браузере. Файлы обрабатываются по очереди, время его обработки примерно равно длительности файла. 10-ти минутное видео обрабатывется примерно 10 минут."
                    )}
                  >
                    {tl("Обработка файла:")}
                  </span>
                ) : (
                  <span>{tl("Загрузка файла:")}</span>
                )}
              </Grid>
              <Grid item xs>
                <MUIProgressBar
                  data={{
                    variant: "determinate",
                    value: fsCourseStore.fileUploadCurrentProgress,
                  }}
                >
                  {fsCourseStore.fileUploadCurrentProgress < 100
                    ? fsCourseStore.fileUploadCurrentProgress + "%"
                    : null}
                </MUIProgressBar>
              </Grid>
              <Grid item>
                <IconButton
                  aria-label={tl("Отменить загрузку файла")}
                  title={tl("Отменить загрузку файла")}
                  onClick={onFileuploadAbort}
                >
                  <img
                    src="/public/images/pix.gif"
                    alt=""
                    className="ic-group ic-group-cancel"
                  />
                </IconButton>
              </Grid>
            </Grid>
          ) : null}
          {fsCourseStore.fileUploadMessage ? (
            <Box color="red" py={1}>
              {fsCourseStore.fileUploadMessage}
            </Box>
          ) : null}
        </Box>
      ) : null}
      {fsStore.isWidget && fsStore.course_id ? (
        <Box p={2}>
          <Grid container spacing={2} alignItems="center">
            <CourseCard course={course} big />
            {fsStore.rootStore.fsCourseStore.filterFilesType !== 'transcription' && (
              <Grid item xs={12} sm={"auto"}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={fsStore.isLoading}
                  onClick={() => {
                    fsStore.onChangeCourse();
                  }}
                >
                  {tl("Файлы других курсов")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      ) : null}
    </>
  );
});
